(function () {
  "use strict";

  function initTimelineSlider(slider) {
    var track = slider.querySelector("[data-timeline-track]");
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length <= 1) return;

    var prevButton = slider.querySelector("[data-timeline-prev]");
    var nextButton = slider.querySelector("[data-timeline-next]");

    var currentIndex = 0;
    var visibleCount = getVisibleCount();

    function getVisibleCount() {
      return window.innerWidth >= 900 ? 2 : 1;
    }

    function getGap() {
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || "0");
      if (!gap && slides.length > 1) {
        var slideStyle = window.getComputedStyle(slides[0]);
        gap = parseFloat(slideStyle.marginRight || "0");
      }
      return isNaN(gap) ? 0 : gap;
    }

    function update() {
      if (!slides.length) return;

      visibleCount = getVisibleCount();
      var maxIndex = Math.max(0, slides.length - visibleCount);

      if (currentIndex > maxIndex) currentIndex = maxIndex;
      if (currentIndex < 0) currentIndex = 0;

      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = getGap();
      var offset = -(slideWidth + gap) * currentIndex;

      track.style.transform = "translate3d(" + offset + "px, 0, 0)";

      if (prevButton) {
        prevButton.disabled = currentIndex === 0;
      }
      if (nextButton) {
        nextButton.disabled = currentIndex >= maxIndex;
      }

      // Mark visible slides as revealed
      var start = currentIndex;
      var end = Math.min(slides.length - 1, currentIndex + visibleCount); // inclusive
      for (var i = start; i <= end; i++) {
        if (!slides[i]) continue;
        slides[i].classList.remove("reveal-invisible");
      }
    }

    function goNext() {
      var maxIndex = Math.max(0, slides.length - visibleCount);
      if (currentIndex < maxIndex) {
        currentIndex += 1;
        update();
      }
    }

    function goPrev() {
      if (currentIndex > 0) {
        currentIndex -= 1;
        update();
      }
    }

    if (prevButton) {
      prevButton.addEventListener("click", goPrev);
    }
    if (nextButton) {
      nextButton.addEventListener("click", goNext);
    }

    // Simple touch swipe on mobile
    var startX = null;

    track.addEventListener(
      "touchstart",
      function (e) {
        if (!e.touches || !e.touches.length) return;
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );

    track.addEventListener(
      "touchend",
      function (e) {
        if (startX === null || !e.changedTouches || !e.changedTouches.length)
          return;

        var endX = e.changedTouches[0].clientX;
        var deltaX = endX - startX;

        if (Math.abs(deltaX) > 50) {
          if (deltaX < 0) {
            goNext();
          } else {
            goPrev();
          }
        }

        startX = null;
      },
      { passive: true }
    );

    window.addEventListener("resize", function () {
      update();
    });

    update();
  }

  function initAll() {
    var sliders = document.querySelectorAll("[data-timeline-slider]");
    Array.prototype.forEach.call(sliders, initTimelineSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Support for Shopify theme editor (reload section)
  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target;
    if (!section) return;
    var slider = section.querySelector("[data-timeline-slider]");
    if (slider) initTimelineSlider(slider);
  });
})();
